<template>
  <div :class="$style.row">
    <ItemRow
      v-bind="$attrs"
      :selected="itemData.selected"
      v-on="$listeners"
    >
      <ItemWithLabel
        :class="$style.displayFlex"
        :column="columns[0]"
      >
        <img
          :class="$style.img"
          :height="46"
          :src="getAppIcon"
          :width="46"
        >
        <Link
          :class="$style.centerAlign"
          :href="getRedirectionUrl(itemData)"
          :text="itemData.organizationName"
        >
          {{ itemData.organizationName }}
        </Link>
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.centerAlign"
        :column="columns[1]"
      >
        {{ itemData.applicationType }}
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.centerAlign"
        :column="columns[2]"
      >
        {{ itemData.commandStatus }}
      </ItemWithLabel>
    </ItemRow>
  </div>
</template>

<script>
import {
  ItemRow,
  ItemWithLabel,
  Link,
} from '@jumpcloud/ui-components';

export default {
  name: 'GoogleAppRow',
  components: {
    Link,
    ItemRow,
    ItemWithLabel,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      required: true,
      type: Object,
    },
  },

  computed: {
    getAppIcon() {
      return this.itemData.iconUrl;
    },
  },

  methods: {
    getRedirectionUrl(itemData) {
      return `#/managedSoftware/google/${itemData.id}/details`;
    },
  },
};
</script>

<style module>
.row {
  border-bottom: var(--jc-border);
}

.displayFlex {
  display: flex;
}

.img {
  border-radius: var(--jc-spacer-small);
  margin-right: var(--jc-spacer-small);
}

.centerAlign {
  margin-bottom: auto !important;
  margin-top: auto;
}
</style>
